// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3b2lT","title":"ClientReferral_title__Ub--v","itemText":"ClientReferral_itemText__3NflZ"};